import { render, staticRenderFns } from "./Customer_Multiple.vue?vue&type=template&id=765620a7&scoped=true"
import script from "./Customer_Multiple.vue?vue&type=script&lang=js"
export * from "./Customer_Multiple.vue?vue&type=script&lang=js"
import style0 from "./Customer_Multiple.vue?vue&type=style&index=0&id=765620a7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "765620a7",
  null
  
)

export default component.exports